import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ReactSession } from 'react-client-session';
import Header from './header';
import Footer from './footer';
ReactSession.setStoreType("localStorage");

function App() {

    const [error, setError] = useState('');
    const [comboId, setComboId] = useState('');
    const [allComboData, setAllComboData] = useState([]);
    const [comboData, setComboData] = useState([]);
    const [productData, setProductData] = useState(null);
    const [comboCart, setComboCart] = useState([]);
    const [comboCategory, setComboCategory] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [currencyValue, setCurrencyValue] = useState(1);
    const [currencySymbol, setCurrencySymbol] = useState('₹');
    
    useEffect(() => {
        const intervalId = setInterval(() => {
            const cValue = sessionStorage.getItem('jmpiCurnceV');
            const cSymbol = sessionStorage.getItem('jmpiCurnceS');
            setCurrencyValue(cValue);
            setCurrencySymbol(cSymbol);
        }, 1000);
        return () => clearInterval(intervalId);
    },[]);
  
    
    const getComboDetails = async () => {
      try{
        const response = await axios.get('https://demo.sninfoserv.com/api/combo/');
        //console.log(response.data);
        if(response.data.status === 'success'){
          setAllComboData(response.data);
        }
      }catch (error) {
        setError({ error: error.message });
      }
    };

    const getProduct = async () => {
        const url = 'https://demo.sninfoserv.com/api/products/view-products/';
        try {
          const res = await axios.get(url);
          if(res.data.status === 'success'){
            const products = res.data.data.filter(item => item.visibility === 'yes');
            setProductData(products);
          }
          //console.log(res.data);
        } catch (error) {
            setError({ error: error.message });
        }
    };
  
 
    const extractProductId = () => {
      const url = window.location.href; 
      const queryString = url.split('?')[1] || ''; 
      const params = new URLSearchParams(queryString);
      const product = params.get('id');
      if (product) {
        setComboId(product);    
      }
    };
    
    useEffect(() => {
        extractProductId();
        getComboDetails(); 
        getProduct();
        const combo = allComboData?.data?.filter(item => item.comboId === comboId);
        setComboData(combo);
        const itemsArray = comboData && comboData[0]?.comboCategory.split(',').map(item => item.trim());
        setComboCategory(itemsArray);
        if(!selectedCategory){
          setSelectedCategory(itemsArray && itemsArray[0]);
        }
    },[allComboData, comboId]);

    

    const addCombo = (code) => {
        setComboCart((prevCart) => {
            const currentCart = prevCart || [];
            if (currentCart.includes(code)) {
              return currentCart.filter(item => item !== code);
            } else {
              if(comboCart.length < comboData[0]?.comboCount){
                return [...currentCart, code];
              }else{
                alert('You can add '+ comboData[0]?.comboCount +' items only');
                return [...currentCart];
              }
            }
          });
    };

    const checkComboCart = (code) => {
        if (comboCart.includes(code)) {
            return true;
        }else{
            return false;
        }
    };

    const selectCategory = (items) => {
        setSelectedCategory(items);
    };

    const addCart = () => {

      if(Number(comboData[0]?.comboCount) === Number(comboCart.length) ){
        const existingCartItems = JSON.parse(sessionStorage.getItem('comboItems')) || [];

        const existingItemIndex = existingCartItems.findIndex(item => item.comboId === comboData[0]?.comboId);
        if (existingItemIndex !== -1) {
            alert('Combo already in Cart!');
        } else {  
          const newItem = {
            comboId: comboData[0]?.comboId,
            comboName: comboData?.[0]?.comboPack,
            comboImage: comboData?.[0]?.comboImage,
            comboPrice: comboData?.[0]?.comboPrice,
            comboQty: 1,
            comboWeight: comboData?.[0]?.comboWeight,
            comboGst: 0,
            comboCount : comboData[0]?.comboCount,
            comboItems : comboCart
          };
        
        existingCartItems.push(newItem);
        sessionStorage.setItem('comboItems', JSON.stringify(existingCartItems));
        setSelectedCategory(comboCategory && comboCategory[0]);
        setComboCart([]);
        alert('Combo added to Cart!');
        }
     }else{
        alert('Please add ' + comboData[0]?.comboCount + ' items!');
     }

    };
    
    console.log(comboCategory);
    
  return (
    <div class="page-wrapper">
    <h1 class="d-none">Jampani Pickles</h1>
  
    <Header />  

    
    <main class="main mb-10 pb-1">
         
         <nav class="breadcrumb-nav container">
             <ul class="breadcrumb bb-no">
                 <li><a href="/">Home</a></li>
                 <li><a href="/">Combos</a></li>
                 <li>{comboData?.[0]?.comboPack}</li>
             </ul>
            
         </nav>
      
         <div class="page-content">
             <div class="container">
                 <div class="product product-single row">
                     <div class="col-md-6 mb-6">
                         <div class="product-gallery product-gallery-sticky product-gallery-vertical">
                             <div class="swiper-container product-single-swiper swiper-theme nav-inner" data-swiper-options="{
                                 'navigation': {
                                     'nextEl': '.swiper-button-next',
                                     'prevEl': '.swiper-button-prev'
                                 }
                             }">
                                 <div class="swiper-wrapper row cols-1 gutter-no">
                                     <div class="swiper-slide">
                                         <figure class="product-image">
                                             <img src={`https://demo.sninfoserv.com/api/combo/images/${comboData?.[0]?.comboImage}`}
                                                 data-zoom-image={`https://demo.sninfoserv.com/api/combo/images/${comboData?.[0]?.comboImage}`}
                                                 alt={comboData?.[0]?.comboPack} width="800" height="900" />
                                         </figure>
                                     </div>
                                    
                                 </div>
                                 <button class="swiper-button-next"></button>
                                 <button class="swiper-button-prev"></button>
                                 
                             </div>
                             <div class="product-thumbs-wrap swiper-container" data-swiper-options="{
                                 'navigation': {
                                     'nextEl': '.swiper-button-next',
                                     'prevEl': '.swiper-button-prev'
                                 },
                                 'breakpoints': {
                                     '992': {
                                         'direction': 'vertical',
                                         'slidesPerView': 'auto'
                                     }
                                 }
                             }">
                                 <div class="product-thumbs swiper-wrapper row cols-lg-1 cols-4 gutter-sm">
                                  
                                     <div class="product-thumb swiper-slide">
                                         <img src={`https://demo.sninfoserv.com/api/combo/images/${comboData?.[0]?.comboImage}`} alt={comboData?.[0]?.comboPack}
                                             width="800" height="900" />
                                     </div>
                                
                                 </div>
                                 <button class="swiper-button-prev"></button>
                                 <button class="swiper-button-next"></button>
                             </div>
                         </div>
                     </div>
                     
                     
                     <div class="col-md-6 mb-4 mb-md-6">
                         <div class="product-details">
                             <h1 class="product-title">{comboData?.[0]?.comboPack}</h1>
                             <div class="product-bm-wrapper">
                                 <div class="product-meta">
                                     <div class="product-categories">
                                         Weight/Item : <span class="product-category">{comboData?.[0]?.comboWeight}g</span>
                                     </div>
                                     <div class="product-sku">
                                         Items Count : <span>{comboData?.[0]?.comboCount}</span>
                                     </div>
                                 </div>
                             </div>

                             {/*  <hr class="product-divider" />
                             
                             <div class="product-price"><ins class="new-price">₹ {parseFloat(productKGPrice).toFixed(2)} <span class="product-short-desc">/ kg</span></ins></div> */}

                             <div class="product-short-desc lh-2">
                                 <p class="list-type-check list-style-none">
                                 {comboData?.[0]?.comboDes}
                                 </p>
                             </div>

                             <hr class="product-divider" />
                             <div class="product-form product-variation-form product-size-swatch">
                                <label class="mb-1">Total Weight :</label>
                                <div class="flex-wrap d-flex align-items-center product-variations">
                                    <a href={`/combo-offers?id=${comboId}`}  className="size active">{Number((comboData?.[0]?.comboWeight * comboData?.[0]?.comboCount)/1000).toFixed(2) } KG</a>
                            
                                </div>
                                
                             </div>

                                        <div class="product-price">
                                            <span >{currencySymbol} {comboData?.[0]?.comboPrice === '' ? 'Loading' : parseFloat(comboData?.[0]?.comboPrice / currencyValue).toFixed(2)}</span>
                                        </div>
                             <hr class="product-divider" />
                             <div class="row">
                             <p>Select Category</p>
                                {comboCategory && comboCategory.map((items, index) => 
                                  <div class="col-4">
                                    <button onClick={() => selectCategory(items)} style={{fontSize: '10px'}} class={`btn ${selectedCategory === items ? 'btn-warning' : 'btn-info'} btn-rounded mt-1 ml-1 w-100`}>{items}</button>
                                  </div>
                                )}
                             </div>
                             <hr class="product-divider" />
                             <div class="row">
                                <p>Select Products</p>
                             {productData && productData.filter(item => item.product_type === selectedCategory).map((items, index) => 
                                <div class="col-4">
                                    <button onClick={() => addCombo(items.product_code)} style={{fontSize: '10px'}} class={`btn ${checkComboCart(items.product_code) ? 'btn-primary' : 'btn-info'} btn-rounded mt-1 ml-1 w-100`}>{items.product}</button>
                                </div>
                                 )}
                             </div>
                             <hr class="product-divider" />
                             <button class="btn btn-primary mt-4 mb-4 ml-1" onClick={addCart}>Add To Cart</button>

                             <div class="social-links-wrapper">
                                 <div class="social-links">
                                     <div class="social-icons social-no-color border-thin">
                                         <a href="#" class="social-icon social-facebook w-icon-facebook"></a>
                                         <a href="#" class="social-icon social-twitter w-icon-twitter"></a>
                                         <a href="#" class="social-icon social-pinterest fab fa-pinterest-p"></a>
                                         <a href="#" class="social-icon social-whatsapp fab fa-whatsapp"></a>
                                         <a href="#" class="social-icon social-youtube fab fa-linkedin-in"></a>
                                     </div>
                                 </div>
                                 <span class="divider d-xs-show"></span>
                                 <div class="product-link-wrapper d-flex">
                                     <a href="#" class="btn-product-icon btn-wishlist w-icon-heart"><span></span></a>
                                     <a href="#" class="btn-product-icon btn-compare btn-icon-left w-icon-compare"><span></span></a>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
                 
            
                 <section class="related-product-section">
                     <div class="title-link-wrapper mb-4">
                         <h4 class="title">Combo Offers</h4>
                         <a href="#" class="btn btn-dark btn-link btn-slide-right btn-icon-right">More
                             Offers<i class="w-icon-long-arrow-right"></i></a>
                     </div>
                     <div class="swiper-container swiper-theme" data-swiper-options="{
                         'spaceBetween': 20,
                         'slidesPerView': 2,
                         'breakpoints': {
                             '576': {
                                 'slidesPerView': 3
                             },
                             '768': {
                                 'slidesPerView': 4
                             },
                             '992': {
                                 'slidesPerView': 4
                             }
                         }
                     }">
                         <div class="swiper-wrapper row cols-lg-3 cols-md-4 cols-sm-3 cols-2">

                         {allComboData && allComboData.data && allComboData.data.map((items, index)=>

                             <div class="swiper-slide product">
                                 <figure class="product-media">
                                     <a href={`/combo-offers?id=${items.comboId}`}>
                                         <img src={`https://demo.sninfoserv.com/api/combo/images/${items.comboImage}`} alt={items.comboPack}
                                             width="300" height="338" />
                                     </a>
                                     <div class="product-action-vertical">
                                         <a  href={`/combo-offers?id=${items.comboId}`} class="btn-product-icon  w-icon-cart"
                                             title="Add to cart"></a>
                                         <a href="#" class="btn-product-icon btn-wishlist w-icon-heart"
                                             title="Add to wishlist"></a>
                                         <a href="#" class="btn-product-icon btn-compare w-icon-compare"
                                             title="Add to Compare"></a>
                                     </div>
                                     <div class="product-action">
                                         <a href={`/combo-offers?id=${items.comboId}`} class="btn-product btn-quickview1" title="Quick View">Quick
                                             View</a>
                                     </div>
                                 </figure>
                                 <div class="product-details">
                                     <h4 class="product-name"><a  href={`/combo-offers?id=${items.comboId}`}>{items.comboPack}</a></h4>
                                     <div class="product-pa-wrapper">
                                         <div class="product-price">{currencySymbol} {Number(parseFloat(items.comboPrice) / currencyValue).toFixed(2)}</div>
                                     </div>
                                 </div>
                             </div>

                          )}    

                             
                         </div>
                     </div>
                 </section>
             </div>
         </div>
      
     </main>
   
    <Footer />
    
    
</div>
  );
}

export default App;
